var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconDollhousePending(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 8.86197L5.23438 4.91536L12 0.96875L18.7656 4.91536L12 8.86197Z",
    stroke: "#818AA6",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12 16.7558V8.86263L5.23438 4.91602V12.8092L12 16.7558Z",
    stroke: "#818AA6",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12 16.7558V8.86263L18.7656 4.91602V12.8092L12 16.7558Z",
    stroke: "#818AA6",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M2.94642 14.2871C1.71353 14.9784 0.991104 15.8177 0.991104 16.7226C0.991104 18.8964 5.16016 20.6917 10.5596 20.9661M21.0544 14.2871C22.2873 14.9784 23.0098 15.8177 23.0098 16.7226C23.0098 18.4409 20.4051 19.9226 16.6469 20.6037C16.1484 20.694 15.6297 20.7703 15.094 20.8311",
    stroke: "#818AA6",
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M9.8125 18.9004L11.5004 20.8954C11.5718 20.9797 11.5612 21.1059 11.4769 21.1772L9.48193 22.8651",
    stroke: "#818AA6",
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconDollhousePending);
export default __webpack_public_path__ + "static/media/icon-dollhouse-pending.ea410052904cbf9d1ba548959892ca15.svg";
export { ForwardRef as ReactComponent };